import * as React from "react";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import { Typography } from "@mui/material";
import { PRIMARY_TEXT_COLOR } from "../../../constants/Colors";
import CustomTextField from "../../../general_components/CustomTextField";
import LoadingButton from "../../../general_components/LoadingButton";

export default function CategoryModal({
  open,
  setOpen,
  categoryName,
  setCategoryName,
  loading,
  handleClose,
  handleAddCategory,
}) {
  const onSubmit = async (e) => {
    e.preventDefault();
    const data = { categoryName: categoryName };
    handleAddCategory(data)
    handleClose();
  };

  return (
    <>
      <Dialog open={open} onClose={handleClose} maxWidth="sm">
        <DialogTitle>
          <Typography
            variant={"body1"}
            style={{ color: PRIMARY_TEXT_COLOR, fontWeight: "600" }}
          >
            Add Category
          </Typography>
        </DialogTitle>
        <DialogContent style={{ width: 350, paddingTop: 15 }}>
          <form onSubmit={onSubmit}>
            <CustomTextField
              autoFocus={true}
              required
              disabled={loading}
              value={categoryName}
              onValueChange={setCategoryName}
              labelName={"Category Name"}
              style={{ marginBottom: 25 }}
            />
            <LoadingButton type={"submit"} loading={loading} text={"Add"} />
          </form>
        </DialogContent>
      </Dialog>
    </>
  );
}
